import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FlagFilledSvg from "@ant-design/icons-svg/es/asn/FlagFilled";
import AntdIcon from "../components/AntdIcon";
var FlagFilled = function FlagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FlagFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FlagFilled.displayName = 'FlagFilled';
}
export default /*#__PURE__*/React.forwardRef(FlagFilled);